import '@/utils/vueDevtoolsConfig';
import Vue from 'vue';
import Vuex from 'vuex';
import uploadfileStore from './modules/upload/upload-file.store';
import uploadedfileStore from './modules/upload/uploaded-file.store';
import uploadjsonfileStore from './modules/upload/upload-json-file.store';
import uploadsnackbarStore from './modules/upload/upload-snackbar.store';
import uploadsnackbarResourceTypeStore from './modules/upload/upload-snackbar-resource-type.store';
import pairingfileStore from './modules/upload/pairing-file.store';
import defectStore from './modules/defect/defect.store';
import defectFormStore from './modules/defect/defect-form.store';
import defectAlertStore from './modules/defect/defect-alert.store';
import aiAnalyzeStore from './modules/defect/ai-analyze.store';
import userStore from './modules/user/user.store';
import userProfileStore from './modules/user/user-profile.store';
import userManagementStore from './modules/user/user-management.store';
import companyStore from './modules/user/company.store';
import dashboardStore from './modules/dashboard/dashboard.store';
import explorerStore from './modules/report/explorer.store';
import imageAlignmentStore from './modules/image/image-alignment.store';
import mapInteractionsStore from './modules/map/mapInteractions.store';
import moduleTreeStore from './modules/panel/moduleTree.store';
import eventStore from './modules/common/event.store';
import menuStore from './modules/common/menu.store';
import commonAlertStore from './modules/common/common-alert.store';
import createDebouncedPersistedState from './createDebouncedPersistedState';
import {
  applyClientStorageVersionMigration,
  getVuexPersistStorageKey
} from '@/utils/clientStorageVersion';
import { isAppDebugEnabled } from '@/utils/debug/debugEnv';
import { appPerfMark, appPerfMeasure } from '@/utils/appBootstrapPerfLog.js';

Vue.use(Vuex);

applyClientStorageVersionMigration();

const debug = isAppDebugEnabled();

/** AI 결함 보기 토글은 세션 UI 상태 — IndexedDB에 저장하지 않음(재접속·로그인 시 항상 off). */
/** user 모듈(프로필)은 authSession이 API로 채움 — IndexedDB에 저장하지 않음. */
function vuexPersistReducer(state) {
  const next = JSON.parse(JSON.stringify(state));
  delete next.user;
  if (next.dashboard) {
    delete next.dashboard.showAiDefectFlag;
    delete next.dashboard.aiDefectLoading;
    /** 세션마다 WFS 재조회 — stale rows 로 ensureWfs skip·AI 필터 빈 목록 방지 */
    delete next.dashboard.wfsDefectRows;
    delete next.dashboard.wfsDefectRowsReportId;
    delete next.dashboard.wfsDefectRowsLoading;
  }
  return next;
}

let resolveStoreRehydrated;
/** IndexedDB rehydrate 완료 시 resolve — main.js에서 세션 bootstrap 전에 await */
export const storeRehydrated = new Promise((resolve) => {
  resolveStoreRehydrated = resolve;
});
appPerfMark('storeRehydrate:start');

function resetAiDefectViewAfterRehydrate(store) {
  appPerfMeasure('storeRehydrate:done', 'storeRehydrate:start');
  // user 모듈은 persist 대상이 아님. logout 호출 시 bootstrap 이후 프로필이 지워지는 레이스가 난다.
  store.commit('dashboard/setShowAiDefectFlag', false);
  store.commit('dashboard/SET_AI_DEFECT_LOADING', false);
  store.commit('defect/SET_AI_INCLUDE', false);
  resolveStoreRehydrated();
}

const store = new Vuex.Store({
  modules: {
    dashboard: dashboardStore,
    menu: menuStore,
    user: userStore,
    userProfile: userProfileStore,
    userManagement: userManagementStore,
    company: companyStore,
    uploadfile: uploadfileStore,
    uploadedfile: uploadedfileStore,
    uploadjsonfile: uploadjsonfileStore,
    uploadsnackbar: uploadsnackbarStore,
    uploadsnackbarResourceType: uploadsnackbarResourceTypeStore,
    pairingfile: pairingfileStore,
    defect: defectStore,
    defectForm: defectFormStore,
    defectAlert: defectAlertStore,
    aiAnalyze: aiAnalyzeStore,
    explorer: explorerStore,
    imageAlignment: imageAlignmentStore,
    mapInteractions: mapInteractionsStore,
    'panel/moduleTree': moduleTreeStore,
    event: eventStore,
    commonAlert: commonAlertStore
  },

  strict: debug,
  plugins: [
    createDebouncedPersistedState({
      key: getVuexPersistStorageKey(),
      reducer: vuexPersistReducer,
      rehydrated: resetAiDefectViewAfterRehydrate
    })
  ]
});

export default store;
